import React, { Component } from "react";
import { Icon, Card, Select } from "antd";
import F from "../../../../Functions";
import { Translate } from "react-translated";

import StatBox from "../../../../components/stat-box";

const Option = Select.Option;

class TotalOpportunitiesUncovered extends Component {
  state = {
    filter_lsp: this.props.filter_lsp,
    expandStats: false,
    period: this.props.period,
    start_date: this.props.start_date,
    end_date: this.props.end_date,
    vo_totals: {
      count: 0,
    },
  };

  filterLSP = (val) => {
    this.setState({
      filter_lsp: val,
    });
    this.props.setInternalFilterChange(true);
  };

  componentDidUpdate() {
    const {
      period,
      start_date,
      end_date,
      filter_lsp,
      internalFilterChange,
    } = this.props;

    if (
      (period !== this.state.period ||
        start_date !== this.state.start_date ||
        end_date !== this.state.end_date ||
        filter_lsp !== this.state.filter_lsp) &&
      !internalFilterChange
    ) {
      this.setState({
        period,
        start_date,
        end_date,
        filter_lsp,
      });
    }
  }

  render() {
    const {
      dashboard,
      user,
      loading,
      period,
      start_date,
      end_date,
    } = this.props;

    let { associations } = this.props;

    associations = associations.filter((item) => item.id !== user.id);

    // console.log("associations==>>" + JSON.stringify(associations));

    const { filter_lsp,
      //  expandStats
       } = this.state;

    let total_umbrella_count = 0,
      cross_sell_policies_uncovered = 0,
      total_bfile_sent = 0,
      retirement_uncovered = 0,
      total_assets_uncovered = 0;

    if (filter_lsp !== "") {
      for (let i = 0; i < dashboard.lsp.length; i++) {
        if (dashboard.lsp[i].user.id === filter_lsp) {
          // F.log('TotalOpportunitiesUncovered ==>> My Stats')
          const user_stats = dashboard.lsp[i].stats;
          total_umbrella_count = user_stats.user_total_umbrella_count || 0;
          cross_sell_policies_uncovered =
            user_stats.user_cross_sell_policies_uncovered;
          total_bfile_sent = user_stats.user_total_bfile_sent || 0;
          retirement_uncovered = user_stats.user_retirement_uncovered;
          total_assets_uncovered = user_stats.total_assets_uncovered || 0;
          break;
        }
      }
    } else {
      // F.log('TotalOpportunitiesUncovered ==>> Agency Stats')
      total_umbrella_count = dashboard.agency_stats.total_umbrella_count || 0;
      cross_sell_policies_uncovered =
        dashboard.agency_stats.cross_sell_policies_uncovered;
      total_bfile_sent = dashboard.agency_stats.total_bfile_sent;
      retirement_uncovered = dashboard.agency_stats.retirement_uncovered;
      total_assets_uncovered =
        dashboard.agency_stats.total_assets_uncovered || 0;
    }

    let date_url = "";
    // comment the following condition for changing the flow of custom dates
    // if (period === "from_to") {
    //   date_url =
    //     "/all/" +
    //     encodeURIComponent(moment(start_date).format("MM/DD/YYYY")) +
    //     "/" +
    //     encodeURIComponent(moment(end_date).format("MM/DD/YYYY"));
    // }
    if (period === "all_bfiles") {
      date_url = "?all_bfiles";
    }

    // new code added for hanlding `My Stats` or `Agency Stats` toggle selection
    // const pncRoute =
    //   user_t.length > 0
    //     ? "cross-sell-policies-uncovered-my-stats"
    //     : "cross-sell-policies-uncovered";

    const pncRoute = "cross-sell-policies-uncovered";

    return (
      <div style={{ marginBottom: 20 }}>
        <Card
          title={
            <div>
              <Icon
                type="appstore"
                style={{ marginRight: 10, color: "#1890ff" }}
              />
              <Translate text={`Total Opportunities Uncovered`} />
            </div>
          }
          bordered={false}
          className="statsDetails have_extra"
          extra={
            user.user_type !== "AGENCY_MANAGER" && (
              <Select
                value={filter_lsp}
                style={{ width: 200 }}
                onChange={(val) => this.filterLSP(val)}
              >
                <Option value="">
                  <Translate text={`Select Agent`} />
                  ...
                </Option>
                <Option value={user.id}>
                  <Translate text={`Me`} />
                </Option>
                {associations
                  .map((asso, i) => {
                    if (asso.user_type === "LSP") {
                      return (
                        <Option value={asso.id} key={i}>
                          {asso.first_name + " " + asso.last_name}
                        </Option>
                      );
                    } else {
                      return null;
                    }
                  })
                  .filter(Boolean)}
              </Select>
            )
          }
        >
          <div className="statsGrid">
            <Card bordered={false} loading={loading}>
              <StatBox
                title="Life Opportunities"
                val={total_bfile_sent}
                color={"blue2"}
                link={"/bfiles/life-opportunities" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="20%"
              />
              <StatBox
                title="Total P&C Items"
                val={cross_sell_policies_uncovered}
                color={"blue1"}
                // link={"/bfiles/cross-sell-policies-uncovered" + date_url}
                link={"/bfiles/" + pncRoute + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="20%"
              />
              <StatBox
                title="Umbrellas Recommended"
                val={total_umbrella_count}
                color={"purple"}
                link={"/bfiles/umbrella-uncovered" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="20%"
              />
              <StatBox
                title="Total Retirement $ Uncovered"
                val={F.dollar_format(retirement_uncovered)}
                color={"blue4"}
                link={"/bfiles/retirement-uncovered" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="20%"
              />
              <StatBox
                title="Total Assets Uncovered"
                val={F.dollar_format(total_assets_uncovered)}
                color={"blue4"}
                link={"/bfiles/total-assets-uncovered" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="20%"
              />
            </Card>
          </div>
          {/* {!loading ? (
                        <div className={(expandStats) ? 'usersGrid expand' : 'usersGrid'}>
                            <Card bordered={false} loading={loading}>
                                {dashboard.lsp.map((lsp, i) => {
                                    F.log("LSP = > ",lsp)
                                    let showUserBox = true;
                                    
                                    if (filter_lsp !== "" && lsp.user.email !== filter_lsp) {
                                        
                                        showUserBox = false;
                                    }
                                    if (showUserBox) {
                                        return (
                                            <UserBox
                                                user={lsp.user}
                                                stats={lsp.stats}
                                                lsp={lsp}
                                                key={i}
                                            />
                                        )
                                    } else {
                                        return null;
                                    }
                                })}
                            </Card>
                            {!expandStats ? (
                                <Button type="primary" size="large" className="show_stats" onClick={() => this.setState({expandStats: !expandStats})}><Translate text={`Show`} /></Button>
                            ) : (
                                <div className="hideStatsContainer">
                                    <Button type="primary" size="large" className="hide_stats" onClick={() => this.setState({expandStats: !expandStats})}><Translate text={`Hide`} /></Button>
                                </div>
                            )}
                        </div>
                    ) : null} */}
        </Card>
      </div>
    );
  }
}

export default TotalOpportunitiesUncovered;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/ea/total-opportunities-uncovered.js